import { FC } from 'react';
import s from './statsItem.module.scss';
import { NumberLoader } from '@components/NumberLoader/NumberLoader';
interface Props {
  value: string;
  text: string;
  isLoading?: boolean;
}
export const StatsItem: FC<Props> = ({
  value,
  text,
  isLoading
}) => {
  return <div className={s.statsItem} data-sentry-component="StatsItem" data-sentry-source-file="StatsItem.tsx">
            <div className={s.statsItem__value}>{isLoading ? <NumberLoader digitCount={3} /> : value}</div>
            <div className={s.statsItem__text}>{text}</div>
        </div>;
};